export default __webpack_public_path__ + "static/media/STL_Investor_meet_Intimation_q3.6e5076bb.pdf";